import { Typography } from "antd";
import React from "react";

function getLabel(color) {
  return <Typography.Text style={{ color, fontSize: 30 }}>*</Typography.Text>;
}

const TAGS = [
  {
    label: getLabel("orange"),
    value: 1,
  },
  {
    label: getLabel("green"),
    value: 2,
  },
  {
    label: getLabel("red"),
    value: 3,
  },
  {
    label: getLabel("blue"),
    value: 4,
  },
  {
    label: getLabel("grey"),
    value: 5,
  },
];

export default TAGS;
